import {
  BaseResourceUse29ny90pfhtji3 as BaseResourceUse,
  waitFor1tw43zglmblfo as waitFor,
  now3ay3meoyffvdk as now,
} from './utils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { lens3m3nj3zkwtu6r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  plus18eogev54fmsa as plus,
  minus27abgkurcn6u0 as minus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Never_getInstance3of1faxayn0qw as Never_getInstance,
  Or37bzl6q9twftg as Or,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delay2kng7ucb3aj62 as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  distinct10qe1scfdvu5k as distinct,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { simplify209licccqij7m as simplify } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionSimplify.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { walkwb3tmcr46qgj as walk } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Mask.mjs';
import { debounce3vjzafx7e7d30 as debounce } from '../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function SharedCollectionUpdatesSocket$Req$wait$lambda(it) {
  return it;
}
var ReqClass;
function Req() {
  if (ReqClass === VOID) {
    class $ extends BaseResourceUse() {
      constructor($outer, condition, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        super($box);
        this.condition_1 = condition;
        this.coveredSince_1 = null;
        var tmp = this;
        tmp.satisfied_1 = lens(this.$this_1.listeningStatus_1, (it) => {
          var tmp0 = it.requirements_1;
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.isEmpty_y1axqb_k$();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              if (element.condition_1.equals(this.condition_1)) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          return tmp$ret$0;
        });
      }
      activate_yijg9v_k$() {
        var _receiver__tnumb7 = this.$this_1.desiredRequirements_1;
        _receiver__tnumb7.set_value_v1vabv_k$(plus(_receiver__tnumb7.get_value_j01efc_k$(), this));
      }
      deactivate_pmdz1g_k$() {
        var _receiver__tnumb7 = this.$this_1.desiredRequirements_1;
        _receiver__tnumb7.set_value_v1vabv_k$(minus(_receiver__tnumb7.get_value_j01efc_k$(), this));
        this.coveredSince_1 = null;
      }
      *wait_bz3vni_k$($completion) {
        return yield* waitFor(this.satisfied_1, SharedCollectionUpdatesSocket$Req$wait$lambda, $completion);
      }
    }
    initMetadataForClass($, 'Req', VOID, VOID, VOID, [0]);
    ReqClass = $;
  }
  return ReqClass;
}
var ListeningStatusClass;
function ListeningStatus() {
  if (ListeningStatusClass === VOID) {
    class $ {
      constructor($outer, fullCondition, requirements) {
        fullCondition = fullCondition === VOID ? Never_getInstance() : fullCondition;
        var tmp;
        if (requirements === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = requirements;
        }
        requirements = tmp;
        this.$this_1 = $outer;
        this.fullCondition_1 = fullCondition;
        this.requirements_1 = requirements;
      }
    }
    initMetadataForClass($, 'ListeningStatus');
    ListeningStatusClass = $;
  }
  return ListeningStatusClass;
}
function nowListening($this, status) {
  var now_0 = now($this.scope_1);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = status.requirements_1.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    if (element.coveredSince_1 == null)
      element.coveredSince_1 = now_0;
  }
  $this.listeningStatus_1.set_value_v1vabv_k$(status);
}
function nowListeningToNothing($this) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = $this.desiredRequirements_1.get_value_j01efc_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    element.coveredSince_1 = null;
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = $this.listeningStatus_1.get_value_j01efc_k$().requirements_1.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
    element_0.coveredSince_1 = null;
  }
  $this.listeningStatus_1.set_value_v1vabv_k$(new (ListeningStatus())($this));
}
function SharedCollectionUpdatesSocket$desiredRequirements$lambda$lambda(it) {
  return toString(it.condition_1);
}
function SharedCollectionUpdatesSocket$listeningStatus$lambda$lambda(it) {
  return toString(it.condition_1);
}
function SharedCollectionUpdatesSocket$updateCondition$slambda($lastSent, $willSend, this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp$ret$0 = toDuration(4, DurationUnit_SECONDS_getInstance());
    yield* delay(tmp$ret$0, $completion);
    var tmp;
    if (equals($lastSent._v, $willSend)) {
      var tmp0_safe_receiver = this$0.log_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp1_safe_receiver = $lastSent._v;
        tmp0_safe_receiver.log_iyb52q_k$(['Update condition to ' + toString_0(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.fullCondition_1) + ' failed (timeout).']);
      }
      $lastSent._v = null;
      _init_$updateCondition(this$0, $lastSent);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 1);
}
function _init_$updateCondition(this$0, lastSent) {
  if (!(ReactiveState__getOrNull_impl_1asnfp(this$0.socket_1.get_connected_12bogw_k$().get_state_wc71uu_k$()) === true)) {
    var tmp0_safe_receiver = this$0.log_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.log_iyb52q_k$(["Can't update condition, socket is closed"]);
    }
    return Unit_instance;
  }
  if (!(lastSent._v == null)) {
    var tmp1_safe_receiver = this$0.log_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.log_iyb52q_k$(["Can't update condition, waiting on tentative send"]);
    }
    return Unit_instance;
  }
  // Inline function 'kotlin.run' call
  var r = this$0.desiredRequirements_1.get_value_j01efc_k$();
  if (r === this$0.listeningStatus_1.get_value_j01efc_k$().requirements_1) {
    var tmp0_safe_receiver_0 = this$0.log_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      tmp0_safe_receiver_0.log_iyb52q_k$(['No need to update condition; already satisfied by exact requirements']);
    }
    return Unit_instance;
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(r, 10));
  var _iterator__ex2g4s = r.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$4 = item.condition_1;
    destination.add_utx5q5_k$(tmp$ret$4);
  }
  var willSend = new (ListeningStatus())(this$0, simplify(Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(distinct(destination))), r);
  if (this$0.listeningStatus_1.get_value_j01efc_k$().fullCondition_1.equals(willSend.fullCondition_1)) {
    nowListening(this$0, willSend);
    var tmp2_safe_receiver = this$0.log_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.log_iyb52q_k$(['No need to update condition; already satisfied by condition match']);
    }
    return Unit_instance;
  }
  lastSent._v = willSend;
  var tmp3_safe_receiver = this$0.log_1;
  if (tmp3_safe_receiver == null)
    null;
  else {
    tmp3_safe_receiver.log_iyb52q_k$(['Sending condition ' + toString(willSend.fullCondition_1)]);
  }
  this$0.socket_1.send_lirmaz_k$(willSend.fullCondition_1);
  launch(this$0.scope_1, VOID, VOID, SharedCollectionUpdatesSocket$updateCondition$slambda(lastSent, willSend, this$0));
}
var SharedCollectionUpdatesSocketClass;
function SharedCollectionUpdatesSocket() {
  if (SharedCollectionUpdatesSocketClass === VOID) {
    class $ {
      constructor(scope, socket, onChange, log) {
        log = log === VOID ? null : log;
        this.scope_1 = scope;
        this.socket_1 = socket;
        this.onChange_1 = onChange;
        this.log_1 = log;
        var tmp = this;
        // Inline function 'kotlin.collections.setOf' call
        var tmp$ret$0 = emptySet();
        // Inline function 'kotlin.also' call
        var this_0 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$0);
        var it = this_0;
        it.addListener_6y9mct_k$(() => {
          var tmp0_safe_receiver = this.log_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            var tmp = it.get_value_j01efc_k$();
            tmp0_safe_receiver.log_iyb52q_k$(['desiredRequirements is now ' + joinToString(tmp, VOID, VOID, VOID, VOID, VOID, SharedCollectionUpdatesSocket$desiredRequirements$lambda$lambda)]);
          }
          return Unit_instance;
        });
        tmp.desiredRequirements_1 = this_0;
        var tmp_0 = this;
        // Inline function 'kotlin.also' call
        var this_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (ListeningStatus())(this));
        var it_0 = this_1;
        it_0.addListener_6y9mct_k$(() => {
          var tmp0_safe_receiver = this.log_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            var tmp = toString(it_0.get_value_j01efc_k$().fullCondition_1);
            var tmp_0 = it_0.get_value_j01efc_k$().requirements_1;
            tmp0_safe_receiver.log_iyb52q_k$(['listeningStatus is now ' + tmp + ' / ' + joinToString(tmp_0, VOID, VOID, VOID, VOID, VOID, SharedCollectionUpdatesSocket$listeningStatus$lambda$lambda)]);
          }
          return Unit_instance;
        });
        tmp_0.listeningStatus_1 = this_1;
        var lastSent = {_v: null};
        this.socket_1.onOpen_i39mgf_k$(() => {
          var tmp0_safe_receiver = this.log_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.log_iyb52q_k$(['Opened.']);
          }
          _init_$updateCondition(this, lastSent);
          return Unit_instance;
        });
        this.socket_1.onMessage_68111k_k$((it) => {
          var tmp0_safe_receiver = this.log_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.log_iyb52q_k$(['Message: ' + it.toString()]);
          }
          this.onChange_1(it);
          var l = lastSent._v;
          var tmp;
          if (!(l == null) && equals(it.condition_1, l.fullCondition_1)) {
            lastSent._v = null;
            nowListening(this, l);
            _init_$updateCondition(this, lastSent);
            tmp = Unit_instance;
          } else if (!(l == null) && !(it.condition_1 == null)) {
            var tmp1_safe_receiver = this.log_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              tmp1_safe_receiver.log_iyb52q_k$(['Condition does not match, though it probably should. (' + toString_0(it.condition_1) + ' == ' + toString(l.fullCondition_1) + ') -eval-> (' + equals(it.condition_1, l.fullCondition_1) + ')']);
            }
            var tmp2_safe_receiver = this.log_1;
            if (tmp2_safe_receiver == null)
              null;
            else {
              tmp2_safe_receiver.log_iyb52q_k$(['--- Received condition structure:']);
            }
            var tmp_0 = ensureNotNull(it.condition_1);
            walk(tmp_0, (it) => {
              var tmp0_safe_receiver = this.log_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.log_iyb52q_k$([toString(getKClassFromExpression(it)) + ' (' + toString(it) + ')']);
              }
              return Unit_instance;
            });
            var tmp3_safe_receiver = this.log_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.log_iyb52q_k$(['--- Expected condition structure:']);
            }
            walk(l.fullCondition_1, (it) => {
              var tmp0_safe_receiver = this.log_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.log_iyb52q_k$([toString(getKClassFromExpression(it)) + ' (' + toString(it) + ')']);
              }
              return Unit_instance;
            });
            var tmp4_safe_receiver = this.log_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.log_iyb52q_k$(['---']);
            }
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        this.socket_1.onClose_nz13c7_k$((it) => {
          var tmp0_safe_receiver = this.log_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.log_iyb52q_k$(['Closed.']);
          }
          lastSent._v = null;
          nowListeningToNothing(this);
          return Unit_instance;
        });
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$5 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
        var debouncedRequirements = debounce(this.desiredRequirements_1, tmp$ret$5, this.scope_1);
        reactive(this.scope_1, VOID, ($this$reactive) => {
          var requirements = $this$reactive.invoke_r7m7el_k$(debouncedRequirements);
          var tmp;
          if (requirements.isEmpty_y1axqb_k$()) {
            nowListeningToNothing(this);
            return Unit_instance;
          }
          $this$reactive.use_rtup5c_k$(this.socket_1);
          _init_$updateCondition(this, lastSent);
          return Unit_instance;
        });
      }
      require_jxou15_k$(condition) {
        return new (Req())(this, condition);
      }
    }
    initMetadataForClass($, 'SharedCollectionUpdatesSocket');
    SharedCollectionUpdatesSocketClass = $;
  }
  return SharedCollectionUpdatesSocketClass;
}
//region block: exports
export {
  SharedCollectionUpdatesSocket as SharedCollectionUpdatesSocket32e1skqgvgdc7,
};
//endregion

//# sourceMappingURL=SharedCollectionUpdatesSocket.mjs.map
